export const types = {
  RESET_AI_INSIGHTS: 'RESET_AI_INSIGHTS',
  SET_AI_INSIGHTS_CONFIG: 'SET_AI_INSIGHTS_CONFIG',
  SET_DISCOVERY: 'SET_DISCOVERY',
  SET_AI_INSIGHTS_LOADING: 'SET_AI_INSIGHTS_LOADING',
  RESET_FILTERS: 'RESET_FILTERS',
  SAVE_WIDGET_CHART_DATA: 'SAVE_WIDGET_CHART_DATA',
  SAVE_WIDGET_TABLE_DATA: 'SAVE_WIDGET_TABLE_DATA',
  SET_WIDGET_CURRENT_LEVEL: 'SET_WIDGET_CURRENT_LEVEL'
};
